import * as Yup from "yup";

export const GoogleSchema = Yup.object().shape({
  mobileNumber: Yup.string().required("Please enter your Mobile Number"),
  address: Yup.string().required("Please enter your address"),
  dateOfBirth: Yup.string().required("Please enter your date of birth"),
});
